export type BillingAccountType = "individual" | "company";

export const BILLING_ADDRESS_REQUIREMENT_MESSAGE =
  "Add a complete billing address to continue. Street, postal code and city are required; company name and VAT number are also required for companies.";

export type BillingAddressForEligibility = {
  address_1?: string | null;
  postal_code?: string | null;
  city?: string | null;
  company?: string | null;
  metadata?: Record<string, unknown> | null;
};

const hasText = (value: unknown): value is string =>
  typeof value === "string" && value.trim().length > 0;

export const isBillingAddressEligibleForAccountType = (
  address: BillingAddressForEligibility,
  accountType: BillingAccountType
): boolean => {
  const hasCompletePostalAddress =
    hasText(address.address_1) &&
    hasText(address.postal_code) &&
    hasText(address.city);

  if (!hasCompletePostalAddress) return false;

  if (accountType === "company") {
    return hasText(address.company) && hasText(address.metadata?.vat_number);
  }

  return !hasText(address.company);
};
